import React, { useState, useEffect } from 'react';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import {
    GridComponent, ColumnsDirective, ColumnDirective,
    Inject, Page, Sort, Toolbar
} from "@syncfusion/ej2-react-grids";
import MenuAdmin from './MenuAdmin';
import Modal from 'react-modal';
import dayjs from 'dayjs';

Modal.setAppElement('#root');

const TransactionsReport = () => {
    const [gridTransaction, setGridTransaction] = useState([]);
    const [viewTransaction, setViewTransaction] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/Transactions/GetAllTransaction`)
            .then((response) => {
                setGridTransaction(response.data);
            });
    }, []);

    const toolbarOptions = [
        'Search'
    ];
    const pageSettingsOptions = {
        pageCount: 3, pageSize: 20, pageSizes: ['20', '40', '60', '80', '100']
    };

    const handleClose = () => setModalIsOpen(false);

    const handleDetailView = (txnID) => {
        try {
            setModalIsOpen(true);
            axios
                .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/Transactions/GetTransactionByTransactionId/` + txnID)
                .then((response) => {
                    setViewTransaction(response.data);
                });
            setIsLoaded(true);
        }
        catch (ex) {
            setModalIsOpen(false);
            alert('Error...');
        }
    }

    // Format the price to USD using the locale, style, and currency.
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    return (
        <div>
            <div class="int-container desktop">
                <img src="/assets/img/int-bg.jpg" alt="" />
            </div>
            <div class="int-container mobile">
                <img src="/assets/img/home-alert-4-mobile.jpg" alt="" />
            </div>
            <div class="main-container">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 ">
                            <div class="profile-menu">
                                <MenuAdmin />
                            </div>
                            <div className='form-container'>
                                <div class="form-group">
                                    <h3 style={{ color: "#fff", width: "100%", textAlign: "center" }}>Transactions</h3>
                                </div>
                                <div id='grdAdmin'>
                                    <GridComponent dataSource={gridTransaction} allowSorting={true} height='auto'
                                        allowPaging={true} pageSettings={pageSettingsOptions} toolbar={toolbarOptions}>
                                        <ColumnsDirective>
                                            <ColumnDirective field='txnID' headerText='Txn Id' width='80' textAlign='left' visible={false} />
                                            <ColumnDirective field='memberName' headerText='Member Name' width='120' textAlign='left' />
                                            <ColumnDirective field='phone' headerText='Mobile' width='80' textAlign='left' />
                                            <ColumnDirective field='txnDate' headerText='Transaction Date' width='100' textAlign='left' type='datetime' format='MM/dd/yyyy HH:mm' />
                                            <ColumnDirective field='txnAmount' headerText='Amount' format="C2" width='70' textAlign='Right' />
                                            <ColumnDirective width="60" textAlign='Center'
                                                template={({ txnID }) => (
                                                    <button className='iconadmin' title='Details' onClick={() => handleDetailView(txnID)}>View</button>
                                                )}
                                            />
                                        </ColumnsDirective>
                                        <Inject services={[Page, Sort, Toolbar]} />
                                    </GridComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <Modal isOpen={modalIsOpen}
                    style={
                        {
                            overlay: {
                                background: 'rgba(0, 0, 0, .8)'
                            },
                            content: {
                                color: 'black',
                                margin: '30px auto',
                                height: '500px'
                            }
                        }
                    }
                >
                    <div>
                        <button className="crossbtn" onClick={handleClose} title='Close'>X</button>
                    </div>
                    <div className="modalcontent">
                        {!isLoaded ?
                            <p style={{ marginTop: '150px', marginLeft: '250px' }}><i class="fa fa-spinner fa-spin" style={{ fontSize: '60px', color: 'black' }}></i></p>
                            :
                            (
                                <div>
                                    <p style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold" }}>Payment Details</p><br />
                                    <p>
                                        Transaction Date: <span className='modaldata'>{dayjs(viewTransaction.txnDate).format("MM/DD/YYYY HH:mm")}</span><br />
                                        Plan Expiry Date: <span className='modaldata'>{dayjs(viewTransaction.txnExpiryDate).format("MM/DD/YYYY HH:mm")}</span><br />
                                        Plan Term(month): <span className='modaldata'>{viewTransaction.termPlan}</span><br />
                                        Amount: <span className='modaldata'>{USDollar.format(viewTransaction.txnAmount)}</span><br />
                                        Card Number: <span className='modaldata'>XXXX-XXXX-XXXX-{(viewTransaction.cardNumber === null) ? 'XXXX' : viewTransaction.cardNumber}</span><br />
                                        Card Type: <span className='modaldata'>{viewTransaction.cardType}</span><br />
                                        Gift Code: <span className='modaldata'>{viewTransaction.code}</span><br />
                                        Payment ID: <span className='modaldata'>{viewTransaction.gatewayTxnID}</span><br />
                                        Status: <span className='modaldata'>{viewTransaction.payStatus}</span>
                                    </p>
                                </div>
                            )
                        }
                    </div>
                </Modal>
            </div>
        </div>
    );
}

export default withRouter(TransactionsReport);